var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.301ccc7e021f18c237bcd170c9536edf.svg#f';
                    var viewUrl = 'sprites.301ccc7e021f18c237bcd170c9536edf.svg#view-f';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };